import React, { createContext, useContext, useEffect, useState, ReactNode } from "react";
import {ManutencaoService} from "../pages/tabelasDeControle/services/manutencaoService";
// ^ ajuste o path conforme sua estrutura real

interface MaintenanceContextValue {
    maintenanceMode: boolean;
    loading: boolean;
    refresh: () => Promise<void>;
}

const MaintenanceContext = createContext<MaintenanceContextValue>({
    maintenanceMode: false,
    loading: true,
    refresh: async () => {},
});

export const useMaintenance = () => useContext(MaintenanceContext);

// cache global p/ evitar chamadas repetidas
let cachedMaintenance: boolean | null = null;

/** Normaliza o formato retornado pelo backend */
function normalizeMaintenanceFlag(raw: any): boolean {
    const src = raw?.data ?? raw;

    const flag =
        src?.manutencao ??
        src?.ativo

    return Boolean(flag);
}

export const MaintenanceProvider = ({ children }: { children: ReactNode }) => {
    const [maintenanceMode, setMaintenanceMode] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchMaintenance = async () => {
        setLoading(true);
        try {
            const data = await ManutencaoService.manutencaoAdmin();
            const isOn = normalizeMaintenanceFlag(data);
            cachedMaintenance = isOn;
            setMaintenanceMode(isOn);
        } catch (error) {
            console.error("Erro ao verificar manutenção (service):", error);
            cachedMaintenance = false;
            setMaintenanceMode(false);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (cachedMaintenance === null) {
            fetchMaintenance();
        } else {
            setMaintenanceMode(cachedMaintenance);
            setLoading(false);
        }
    }, []);

    return (
        <MaintenanceContext.Provider value={{maintenanceMode, loading, refresh: fetchMaintenance}}>
            {children}
        </MaintenanceContext.Provider>
    );
}
